/**
 * Version constants (CFG-005). Must equal /versions.json — enforced by tests.
 * SCHEMA_VERSION follows docs/DATABASE_SCHEMA.md (1.10.0: self-signup's doctorApplications,
 * platformConfig).
 */
export const PLATFORM_VERSION = "3.0.0-alpha.1";
export const SCHEMA_VERSION = "1.10.0";
export const API_VERSION = "v1";
export const API_BASE_PATH = `/api/${API_VERSION}`;
//# sourceMappingURL=versions.js.map